
import { companyModule } from '@/store/modules/store-accessor';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class RecurrenceCheckBox extends Vue {
    @Prop({ required: true }) value!: any;

    mounted() {
      companyModule.getCompanyInfo();
    }

    get hasNotAdvancedPlan() {
        return !companyModule.company?.modules?.includes('DFB_ADVANCED_PLAN');
    }

}
